import React from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import _ from "lodash";
import {submit} from "redux-form";
import $ from "jquery";
import {injectIntl} from "react-intl";

import {AccessRights, PARTS} from "../../schemas/accessRightsModel";
import {showSavingProgress, showSuccessPopup, updateCustomerInfo} from "../AddNewEntity/AddNewEntityActions";
import misc from "../../misc";
import {errorBox_Show, messageBoxEx_Show} from "../../actions/A_Popups";
import {getMasterProfile} from "./accountPageFunctions";
import {toggleFormSubmitted, toggleSectionOpened} from "./AccountActions";
import {ACCOUNT_SECTIONS} from "./Sections/sectionNames";

class AccountPageFooter extends React.Component {

  componentWillReceiveProps(nextProps) {
    if (nextProps.formSubmitted && !this.props.formSubmitted) { // listen to redux form submitted
      this.submitForm();
    } else if (nextProps.updateSuccess) {
      this.props.showSuccessPopup();
      if (!nextProps.__error__) {
        const {urlOnSave} = this.props.accountPageInfo;
        hashHistory.push(urlOnSave);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.triggerSubmit && !prevProps.triggerSubmit && this.props.syncErrors) {
      let errorInputName = Object.keys(this.props.syncErrors)[0];
      if (errorInputName === "shippingAddress") {
        errorInputName = "shippingAddress." + Object.keys(this.props.syncErrors.shippingAddress)[0];
      }
      // console.log("errorInputName", errorInputName);
      const $scrollWrapper = $(".app-content-wrapper");
      const $errorInput = $("[name='"+errorInputName+"']");
      if ($scrollWrapper && $errorInput && $errorInput.position()) {
        this.openSectionAndScroll($scrollWrapper, $errorInput);
      }
    }
  }

  openSectionAndScroll = ($scrollWrapper, $errorInput) => {
    if (Object.keys(this.props.syncErrors)[0] === "shippingAddress") {
      if (!this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.business_address)) {
        this.props.toggleSectionOpened(ACCOUNT_SECTIONS.business_address);
        setTimeout(() => {
          this.scrollWrapperToErrorInput($scrollWrapper, $errorInput);
        }, 300);
      } else {
        this.scrollWrapperToErrorInput($scrollWrapper, $errorInput);
      }
    } else if (!this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.company_information)) {
      this.props.toggleSectionOpened(ACCOUNT_SECTIONS.company_information);
      setTimeout(() => {
        this.scrollWrapperToErrorInput($scrollWrapper, $errorInput);
      }, 300);
    } else {
      this.scrollWrapperToErrorInput($scrollWrapper, $errorInput);
    }
  }

  scrollWrapperToErrorInput = ($scrollWrapper, $errorInput) => {
    const labelHeight = 24;
    $scrollWrapper.animate({scrollTop: $errorInput.position().top - labelHeight}, 800); //scroll to error input
  };

  handleFooterCancelClick = () => {
    hashHistory.goBack();
  };

  handleFooterSaveClick = () => {
    this.props.submit('newEntity'); // first validate all required inputs
  };

  submitForm = () => {
    const {intl} = this.props;
    this.props.toggleFormSubmitted(false); // set redux-dead-drop to false
    const {clientType, clientSubType, isNew, entityId} = this.props.accountPageInfo;
    const {fabricatorNeedToSignAgreement, kitchenProgramType, kitchenPaymentType, bathroomProgramType,
      bathroomPaymentType} = this.props.subscriptionsInfo;
    const {saveCC, ccName, ccCVV, ccExpYear, ccExpMonth, ccNum} = this.props.billingInformation;
    const {docuSignObj} = this.props.docuSignPopupState;
    const {subscriptions, formValues, masterProfile, assignedEntities, activeWebHookDataType, fabricatorSubscriptions, store} = this.props;

    //console.log("formValues", formValues);

    if (fabricatorNeedToSignAgreement && subscriptions.length >= 1) {
      this.props.errorBox_Show({
        title: intl.formatMessage({id: "messageBox.errorTitle"}),
        text: intl.formatMessage({id: "account.errors.fabricatorNeedToSignAgreement"}),
        rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
        isRightButtonVisible: true
      });
      return;
    }
    if (kitchenProgramType === 'enterprise' || kitchenProgramType === 'basics') {
      if (kitchenPaymentType.period !== 'monthly' && kitchenPaymentType.period !== 'annually') {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.kitchenPaymentType"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    }
    if (bathroomProgramType === 'enterprise' || bathroomProgramType === 'basics') {
      if (bathroomPaymentType.period !== 'monthly' && bathroomPaymentType.period !== 'annually') {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.bathroomPaymentType"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    }

    const logo = document.getElementById('logo');
    const file = logo ? logo.files[0] : null;
    let formData = new FormData();
    if (file) {
      formData.append('file', file);
    }

    if (formValues.enableDeposit) {
      if (/[^0-9\.]/g.test(formValues.deposit) || _.trim(formValues.deposit).length === 0) {
        this.props.messageBoxEx_Show(
          true,
          intl.formatMessage({id: "messageBox.errorTitle"}),
          intl.formatMessage({id: "account.errors.depositErrorTitle"}),
          intl.formatMessage({id: "account.errors.depositErrorText"}),
        );
        return;
      }
    }

    if (clientType !== 'Customer') {
      if (clientType === 'Client') {
        let errors = [];
        formValues.billingAddress = formValues.billingAddress || {
          address1: '',
          city: '',
          state: '',
          zip: ''
        };
        if (_.trim(formValues.billingAddress.address1).length === 0) {
          errors.push(intl.formatMessage({id: "account.errors.addressRequired"}));
        }
        if (_.trim(formValues.billingAddress.city).length === 0) {
          errors.push(intl.formatMessage({id: "account.errors.cityRequired"}));
        }
        if (_.trim(formValues.billingAddress.state).length === 0) {
          errors.push(intl.formatMessage({id: "account.errors.stateRequired"}));
        }
        if (_.trim(formValues.billingAddress.zip).length === 0) {
          errors.push(intl.formatMessage({id: "account.errors.zipRequired"}));
        }
        if (errors.length > 0) {
          this.props.messageBoxEx_Show(true, 'error', intl.formatMessage({id: "account.errors.billingErrors.title"}), errors.join('<br />'));
          return;
        }
      }
    } else {
      formValues.billingAddress = {};
      formValues.shippingAddress = {};

      if(!formValues.firstName || !formValues.lastName){
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: "First Name and Last Name are required",
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    }

    if (formValues.redirectUrl && !_.startsWith(formValues.redirectURL.toLowerCase(), "http"))
      formValues.redirectURL = "http://" + formValues.redirectURL;

    formValues.clientType = clientType;
    if (clientSubType && clientSubType !== 'null') {
      formValues.clientSubType = clientSubType;
    }
    formValues.masterProfile = masterProfile;
    formValues.assignedEntities = {
      fabricators: assignedEntities.fabricators,
      stores: assignedEntities.stores
    };

    formValues.id = isNew ? 0 : entityId;

    if (saveCC) {
      formValues.ccName = ccName;
      formValues.ccNum = ccNum;
      formValues.ccExpMonth = ccExpMonth;
      formValues.ccExpYear = ccExpYear;
      formValues.ccCVV = ccCVV;

      if (!formValues.billingAddress || _.trim(formValues.billingAddress.address1 || '').length === 0
        || _.trim(formValues.billingAddress.state || '').length === 0
        || _.trim(formValues.billingAddress.zip || '').length === 0
      ) {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.billingRequired"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }

    }

    const iClickLeadCount = parseInt(formValues.clickLeadCount);
    if (formValues.clickLeadCapture || formValues.clickLeadCaptureDashboard) {
      if (isNaN(iClickLeadCount) || iClickLeadCount < 1 || iClickLeadCount > 9999) {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.clickLeadCount"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCount)) {
      formValues.clickLeadCount = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountOnQuote = parseInt(formValues.clickLeadCountOnQuote);
    if (formValues.clickLeadCaptureOnQuote) {
      if (isNaN(iClickLeadCountOnQuote) || iClickLeadCountOnQuote < 1 || iClickLeadCountOnQuote > 9999) {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.clickLeadCountOnQuote"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountOnQuote)) {
      formValues.clickLeadCountOnQuote = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountKitchen = parseInt(formValues.clickLeadCountKitchen);
    if (formValues.clickLeadCaptureKitchen|| formValues.clickLeadCaptureDashboardKitchen) {
      if (isNaN(iClickLeadCountKitchen) || iClickLeadCountKitchen < 1 || iClickLeadCountKitchen > 9999) {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.clickLeadCountOnQuote"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountKitchen)) {
      formValues.clickLeadCountKitchen = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountOnQuoteKitchen = parseInt(formValues.clickLeadCountOnQuoteKitchen);
    if (formValues.clickLeadCaptureOnQuoteKitchen) {
      if (isNaN(iClickLeadCountOnQuoteKitchen) || iClickLeadCountOnQuoteKitchen < 1 || iClickLeadCountOnQuoteKitchen > 9999) {
        this.props.errorBox_Show({
          title: intl.formatMessage({id: "messageBox.errorTitle"}),
          text: intl.formatMessage({id: "account.errors.clickLeadCountOnQuote"}),
          rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountOnQuoteKitchen)) {
      formValues.clickLeadCountOnQuoteKitchen = 10; //if clickleadcount isn't a number, reset to default
    }

    docuSignObj.isEnabled = formValues.enableDocuSign;
    formValues.docuSignAuth = JSON.stringify(docuSignObj);
    if (!formValues.webHookProperties || !formValues.webHookProperties.dataType) {
      if (!formValues.webHookProperties) {
        formValues.webHookProperties = {};
      }
      formValues.webHookProperties.dataType = activeWebHookDataType;
    }

    formValues.language = formValues.language || "en-US";
    formValues.measurement = formValues.measurement || "imperial";

    formValues.fabricatorSubscriptions = {...fabricatorSubscriptions};
    //console.log(283, fabricatorSubscriptions, store.newaccount.fabricatorSubscriptions, formValues);
    const checkSave = document.getElementById('chkSave');
    formValues.RefreshCacheOnSave = !!(checkSave && checkSave.checked);
    formData.append('json', JSON.stringify(formValues));
    this.props.showSavingProgress();
    this.props.updateCustomerInfo(formData);
  };

  render() {
    const {clientType, entityId} = this.props.accountPageInfo;
    return (
      <div className="app-content-footer app-content-footer--fixed">
        <div className="app-content-footer__buttons">
          {(clientType === "Fabricator") && entityId ? (
            <div className="account-save">
              <label>
                <input className="ui-checkbox2" type="checkbox" defaultChecked={true} id="chkSave"></input>
                Clear Fabricator's Cache on Save
              </label>
            </div>
          ) : null}
          <button className="ui-button ui-button--blue" onClick={this.handleFooterCancelClick}>
            <span className="ui-button-text ui-button--uppercase">Cancel</span>
          </button>
          <button className={"ui-button ui-button--green ui-button--large" + (!this.props.rights.isSaveButtonVisible ? " ui-button--disabled" : "")}
                  disabled={!this.props.rights.isSaveButtonVisible}
                  onClick={this.handleFooterSaveClick}>
            <span className="ui-button-text ui-button--uppercase">Save</span>
          </button>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  const AR = AccessRights.get(store);
  const {updateSuccess, showESignatureOverlay, fabricatorSubscriptions, subscriptions, assignedEntities} = store.newaccount;
  const {sectionsOpened, accountPageInfo, subscriptionsInfo, billingInformation, activeWebHookDataType, formSubmitted} = store.accountState;

  let isSaveButtonVisible = true;
  if (accountPageInfo.clientType === 'Client') {
    isSaveButtonVisible = AR.v(PARTS.HUB_BUTTON_CUSTOMERS)
  }
  isSaveButtonVisible = isSaveButtonVisible && !showESignatureOverlay;
  const rights = {
    isSaveButtonVisible
  }
  //console.log(fabricatorSubscriptions);
  return {
    sectionsOpened,
    updateSuccess,
    accountPageInfo,
    subscriptionsInfo,
    billingInformation,
    subscriptions,
    assignedEntities,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
    masterProfile: getMasterProfile(store),
    docuSignPopupState: store.popups.docuSignPopupState,
    activeWebHookDataType,
    rights,
    formSubmitted,
    fabricatorSubscriptions,
    store,
    syncErrors: (store.form && store.form.newEntity && store.form.newEntity.syncErrors) || null
  };
};

const mapDispatchToProps = {
  showSuccessPopup,
  errorBox_Show,
  showSavingProgress,
  updateCustomerInfo,
  submit,
  toggleFormSubmitted,
  toggleSectionOpened,
  messageBoxEx_Show
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountPageFooter)
);
